.container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.default {
  gap: 4px;
}
.default .status {
  height: 16px;
  padding: 0 6px;
  font-size: 8px;
}

.large {
  gap: 6px;
}
.large .status {
  height: 33px;
  padding: 0 14px;
  font-size: 17px;
  border-radius: 16px;
}

.status {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  border-radius: 10px;
}

.completed {
  background-color: var(--color-feedback-positive-100);
  color: var(--color-feedback-positive-600);
}

.completed-late {
  background-color: var(--color-feedback-positive-100);
  color: var(--color-feedback-positive-600);
}

.not-started {
  background-color: var(--color-neutral-300);
  color: var(--color-neutral-600);
}

.not-executed {
  background-color: var(--color-feedback-danger-300);
  color: #FFFFFF;
}

.error {
  background-color: #F9DC95;
  color: var(--color-feedback-danger-600);
}

.in-progress {
  background-color: #DEECFF;
  color: #00357A;
}

.awaiting-end {
  background-color: #DEECFF;
  color: #00357A;
}

.awaiting-justification {
  background-color: var(--feedback-danger-100, var(--color-feedback-danger-100, #FFEAEA));
  color: var(--feedback-danger-600, var(--color-feedback-danger-600, #7A130A));
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */